import { render } from "./textaPendulum.vue?vue&type=template&id=6616ba90&scoped=true"
import script from "./textaPendulum.vue?vue&type=script&lang=js"
export * from "./textaPendulum.vue?vue&type=script&lang=js"

import "./textaPendulum.vue?vue&type=style&index=0&id=6616ba90&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6616ba90"]])

export default __exports__